import { useTimedAlerts } from 'kagr-ui';
import * as React from 'react';
import useRestService from '../shared/rest-service';

/**
 * @function useAnnouncement - Custom hook for the announcement edit pages
 */
const useAnnouncement = (client: number | 'global' | undefined) => {
  const { getAuth, postAuth } = useRestService();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [announcement, setAnnouncement] = React.useState<string>('');
  const [errorMessage, setErrorMessage] = React.useState<string>('');
  const { successMessage, setSuccessMessage } = useTimedAlerts();

  React.useEffect(() => {
    if (client) {
      setAnnouncement('');
      fetchAnnouncement(client);
    }
  }, [client]);

  const fetchAnnouncement = (subPath: number | 'global') => {
    getAuth(`api/announcements/${subPath}`)
      .then((res: string) => {
        setAnnouncement(res);
        setLoading(false);
      })
      .catch(err => {
        setErrorMessage(err);
        setLoading(false);
      });
  };

  const updateAnnouncement = (subPath: number | 'global', content: string) => {
    setLoading(true);
    postAuth(`api/announcements/${subPath}`, content)
      .then(response => {
        setLoading(false);
        if (response.success) {
          setSuccessMessage(response.message);
        } else {
          setErrorMessage(response.message);
        }
      })
      .catch(err => {
        setErrorMessage(err.responseJSON.message);
        setLoading(false);
      });
  };

  return {
    loading,
    announcement,
    errorMessage,
    successMessage,
    updateAnnouncement
  };
};

export default useAnnouncement;
